import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { FirebaseAuthService } from './firebase-auth.service';
import { UtilityFunctionsService } from './utility-functions.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(
    private readonly firebaseAuth: FirebaseAuthService,
    private readonly router: Router,
    private readonly utilityService: UtilityFunctionsService,
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    if (!this.firebaseAuth.currentUser) {
      await this.waitForAuthUser(4000);
    }
    if (!this.firebaseAuth.currentUser) {
      return this.router.parseUrl('/');
    }

    // Force a token refresh: an admin whose claim was granted minutes ago would
    // otherwise be bounced until their cached ID token expires.
    const isAdmin = await this.firebaseAuth.hasAdminClaim(true);
    if (isAdmin) {
      return true;
    }

    // Signed in but no admin claim: explain the bounce instead of a silent redirect.
    this.utilityService.showImportantErrorSnackBar(
      'No access to Generation Studio: the admin claim is not granted for this account. Contact an administrator to request access.',
      0,
      6000,
    );
    return this.router.parseUrl('/');
  }

  private waitForAuthUser(timeoutMs: number): Promise<void> {
    return new Promise((resolve) => {
      if (this.firebaseAuth.currentUser) {
        resolve();
        return;
      }

      const timeoutId = setTimeout(() => {
        subscription?.unsubscribe();
        resolve();
      }, timeoutMs);

      const subscription = this.firebaseAuth.firebaseUser.subscribe(() => {
        clearTimeout(timeoutId);
        subscription.unsubscribe();
        resolve();
      });
    });
  }
}
